import FortyOneLumber from '../images/41Lumber.jpg';
import WeVPNLogo from '../images/WeVPN.png';
import SwiftTransLogo from '../images/SwiftTrans.jpg';
import CardGlassLogo from '../images/CardinalGlass.jpg';
import KSIGlobal from '../images/KSIGlobal.png';

const workExperience = [
  {
    company: '41 Lumber',
    position: 'Bookkeeper',
    date: '10/2025 - Present',
    location: 'Houghton, MI',
    logo: FortyOneLumber,
    description: [
      'Record, reconcile, and verify all daily financial transactions with high accuracy and attention to detail',
      'Prepare and balance daily cash reports, perform bank deposits, and ensure petty cash and tills remain accurate',
      'Maintain organized vendor and credit P.O. files, process credits and returns, and monitor outstanding balances',
      'Support financial integrity through accurate data entry, documentation, and reporting within accounting systems',
      'Assist with inventory audits, cost tracking, and monthly financial summaries to support store profit goals'
    ]
  },
  {
    company: 'WeVPN',
    position: 'Quality Control Assistant - Company Shutdown',
    date: '04/2020 - 08/2023',
    location: 'Remote',
    logo: WeVPNLogo,
    description: [
      'Test and assure the development team that bug fixes and new implementations were appropriately fixed',
      'Write detailed technical and concise write-ups of findings',
      'Interact with customers and ensure changes and implementations are working accordingly'
    ]
  },
  {
    company: 'Swift Transport',
    position: 'Commercial Truck Driver',
    date: '10/2023 - 06/2024',
    location: 'Appleton, WI',
    logo: SwiftTransLogo,
    description: [
      'Assure truck is up to DOT standards via a Pre-Trip inspection',
      'Manage my clocks and trip plan to ensure an on-time and safe delivery',
      'Maintain a professional appearance and approach at shippers and receivers'
    ]
  },
  {
    company: 'Cardinal Glass',
    position: 'Tempering Lead',
    date: '06/2021 - 02/2023',
    location: 'Spring Green, WI',
    logo: CardGlassLogo,
    description: [
      'Lead a crew of 5-6 people on a Furnace and help them develop required skills',
      'Manage all scheduling and ensure everything is produced and shipped on time',
      'Assess situations with production lines and prioritize based on external factors'
    ]
  },
  {
    company: 'KSI Global',
    position: 'Data Analysis - Volunteer',
    date: '01/2025 - 3/2025',
    location: 'Remote',
    logo: KSIGlobal,
    description: [
      'Pull analytical reports and make spreadsheets based on those reports to present to individual Divisions and Squads.',
      'This involves reporting on 5,000-6,000 people across 8 Divisions and 55+ Squads.'
    ]
  }
];

export default workExperience;
